import classNames from 'classnames';
import React, { useCallback, useRef } from 'react';
import { Checkbox as TPACheckbox } from '@wix/wix-ui-tpa/cssVars';
import { ForcedState, useForcedState } from '../../contexts/forced-state-context';
import styles from './checkbox-field-wut.module.scss';
import { classes } from './checkbox-field-wut.st.css';
import { RequiredIndicator, RequiredIndicatorPlacement } from '@wix/ambassador-forms-v4-form/types';
import { FieldRichLabelWUT } from '../field-rich-label/field-rich-label-wut';
import { useFocusFieldEvent } from '../../contexts/events-context';
export const CheckboxFieldWUT = _ref => {
  let {
    id,
    label,
    disabled = false,
    value = false,
    onChange,
    onFocus,
    onBlur,
    hasError = false,
    errorMessage,
    required,
    FieldLayout,
    requiredIndicatorType = RequiredIndicator.ASTERISK,
    requiredIndicatorPlacement = RequiredIndicatorPlacement.AFTER_FIELD_TITLE
  } = _ref;
  const forcedHover = useForcedState().includes(ForcedState.INPUT_FIELDS_HOVER);
  const checkboxRef = useRef(null);
  const handleChange = useCallback(event => {
    onChange == null || onChange(event.checked);
  }, [onChange]);
  useFocusFieldEvent(() => {
    var _checkboxRef$current;
    (_checkboxRef$current = checkboxRef.current) == null || _checkboxRef$current.focus({
      preventScroll: true
    });
  }, id);
  return /*#__PURE__*/React.createElement(FieldLayout, {
    fieldId: id,
    renderLabel: () => null,
    renderInput: () => /*#__PURE__*/React.createElement("div", {
      onBlur: onBlur,
      onFocus: onFocus
    }, /*#__PURE__*/React.createElement(TPACheckbox, {
      newErrorMessage: true,
      className: classNames(styles.checkbox, classes.root, classes.checkbox, {
        [classes.error]: hasError,
        [classes.hover]: forcedHover
      }),
      label: /*#__PURE__*/React.createElement(FieldRichLabelWUT, {
        label: label,
        disabled: disabled,
        required: required,
        requiredIndicatorType: requiredIndicatorType,
        requiredIndicatorPlacement: requiredIndicatorPlacement
      }),
      checked: Boolean(value),
      onChange: handleChange,
      disabled: disabled,
      error: hasError,
      errorMessage: errorMessage,
      required: required,
      showAsterisk: false,
      ref: checkboxRef
    })),
    renderDescription: () => null
  });
};
//# sourceMappingURL=checkbox-field-wut.js.map